<div class="modal-window confirm">
  <div class="modal-content">
    <div class="confirm-header">
      <i class="fa fa-download confirm-icon"></i>
      <span class="confirm-header-text">{{ confirmHeader }}</span>
    </div>
    <div class='confirm-message'>
      <p>{{ confirmMessage }}</p>
    </div>
    <div class="confirm-button-row">
        <button class="btn" (click)="onHideModalClick()">Close</button>
    </div>
  </div>
</div>
